import { Link } from "wouter";
import { Button } from "@/components/ui/button";

const CTASection = () => {
  const metrics = [
    { value: "98%", label: "Germination Rate" },
    { value: "15-30%", label: "Yield Increase" },
    { value: "24/7", label: "Expert Support" },
    { value: "100%", label: "Satisfaction" }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="bg-accent bg-opacity-10 rounded-2xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-1/3 h-full opacity-10">
            <img 
              src="https://images.unsplash.com/photo-1500651230702-0e2d8a49d4ad?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8YWdyaWN1bHR1cmFsIGxhbmRzY2FwZXN8fHx8fHwxNjk3ODM5MDgx&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=400" 
              alt="Agricultural landscape" 
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center relative z-10">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary font-heading">
                Ready to Enhance Your Harvest?
              </h2>
              <p className="text-neutral-700 mb-6">
                Join thousands of satisfied farmers who have transformed their yields with 
                Varsha Seeds. Our agricultural experts are ready to help you select the 
                perfect seed varieties for your specific conditions.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link href="/contact">
                  <Button className="bg-primary hover:bg-primary/90 text-white rounded-full">
                    Contact Us Today
                  </Button>
                </Link>
                <Link href="/products">
                  <Button variant="outline" className="bg-white hover:bg-background text-primary rounded-full border-primary">
                    Browse Products
                  </Button>
                </Link>
              </div>
            </div>
            
            <div>
              <div className="grid grid-cols-2 gap-4">
                {metrics.map((metric, index) => (
                  <div key={index} className="bg-white p-4 rounded-lg shadow-md text-center">
                    <div className="text-3xl font-bold text-primary mb-1">{metric.value}</div>
                    <p className="text-neutral-700 text-sm">{metric.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
